import { Component, Input } from '@angular/core';

@Component({
    selector: 'syn-detail-card',
    templateUrl: './detail-card.component.html',
    styleUrls: ['./detail-card.component.scss']
})
export class DetailCardComponent {
    @Input() headerText = '';
    @Input() headerSubTitle = '';
    @Input() noPadding = false;
    @Input() maxContentHeight: string = null;
    @Input() expansion = false;
    @Input() fillHeight = false;
}
